/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Track } from './Track';
import {
    TrackFromJSON,
    TrackFromJSONTyped,
    TrackToJSON,
} from './Track';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface RemixContestsRelated
 */
export interface RemixContestsRelated {
    /**
     * 
     * @type {Array<User>}
     * @memberof RemixContestsRelated
     */
    users?: Array<User>;
    /**
     * 
     * @type {Array<Track>}
     * @memberof RemixContestsRelated
     */
    tracks?: Array<Track>;
    /**
     * Per-contest entry counts keyed by the contest's parent track id (hashid). Lets the discovery UI render entry counts without issuing an extra `/tracks/{id}/remixes?limit=0` per card.
     * @type {{ [key: string]: number; }}
     * @memberof RemixContestsRelated
     */
    entryCounts?: { [key: string]: number; };
}

/**
 * Check if a given object implements the RemixContestsRelated interface.
 */
export function instanceOfRemixContestsRelated(value: object): value is RemixContestsRelated {
    let isInstance = true;

    return isInstance;
}

export function RemixContestsRelatedFromJSON(json: any): RemixContestsRelated {
    return RemixContestsRelatedFromJSONTyped(json, false);
}

export function RemixContestsRelatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemixContestsRelated {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'users': !exists(json, 'users') ? undefined : ((json['users'] as Array<any>).map(UserFromJSON)),
        'tracks': !exists(json, 'tracks') ? undefined : ((json['tracks'] as Array<any>).map(TrackFromJSON)),
        'entryCounts': !exists(json, 'entry_counts') ? undefined : json['entry_counts'],
    };
}

export function RemixContestsRelatedToJSON(value?: RemixContestsRelated | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'users': value.users === undefined ? undefined : ((value.users as Array<any>).map(UserToJSON)),
        'tracks': value.tracks === undefined ? undefined : ((value.tracks as Array<any>).map(TrackToJSON)),
        'entry_counts': value.entryCounts,
    };
}

